<template>
	<div class="page" :style="{height:fixedHeight+'px'}" style="position: relative;overflow-y: auto;">
		<!-- 头部 -->
		<div class="titleView">
			<el-row>
				<el-col :span="4">申请批次号: {{detailData.procureRequestNo}}</el-col>
				<el-col :span="4" v-if="detailData.createOperationInfo">申请日期: {{detailData.createOperationInfo.operationTime}}</el-col>
				<el-col :span="4" v-if="detailData.createOperationInfo">申请门店: {{detailData.shopInfo.shopName}}
				</el-col>
				<el-col :span="4" v-if="detailData.createOperationInfo">申请人: {{detailData.createOperationInfo.userName}}
				</el-col>
				<el-col :span="4">采购状态: 审批驳回</el-col>
				<el-col :span="4">
					<el-button type="warning" @click="handleBackClick" size="small">返回</el-button>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="4" v-if="detailData.checkInfo">审批人: {{detailData.checkInfo.checkUserInfo.userName}}
				</el-col>
				<el-col :span="4" v-if="detailData.checkInfo">审批日期:  {{detailData.checkInfo.checkUserInfo.operationTime}}</el-col>
				<el-col :span="4">采购数量: {{detailData.procureGoodsCount}}</el-col>
				<el-col :span="4">备注: {{detailData.remarks==''?'--':detailData.remarks}}</el-col>
			</el-row>
		</div>
		<div class="scrollView" style="overflow-y: scroll;">
			<!-- 商品类 -->
			<div class="shopClass" v-if="shops.length > 0">
				<div class="comH2" @click="handleShopClick">
					<div>商品类</div>
					<i class="el-icon-caret-bottom" v-if="showShop"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showShop">
					<el-table ref="multipleTable1" :data="shops" tooltip-effect="dark" size="small">
						<el-table-column :key="1" prop="title" label="商品名称" width="220" />
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 2" size="small"
									type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="brand" label="品牌" align="center" />
						<el-table-column :key="3" prop="skuValue" label="规格" align="center" width="120" />
						<el-table-column :key="5" prop="unit" label="单位" align="center" />
						<el-table-column :key="4" prop="count" label="数量" align="center" />
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock.length > 0">
										<div v-for="(item,index) in scope.row.shop_stock" :key="index">
											{{item.shop_name}}:{{item.shop_stock}}</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #0000FF;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="9" prop="procureGoodsRemark" label="备注" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.procureGoodsRemark==''?'--':scope.row.procureGoodsRemark}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160" />
					</el-table>
					<div class="allNum">
						<div>共{{shopCount}}件</div>
					</div>
				</div>
			</div>
			<!-- 医疗类 -->
			<div class="shopClass" v-if="drugs.length > 0">
				<div class="comH2" @click="handleDrugClick">
					<div>医疗类</div>
					<i class="el-icon-caret-bottom" v-if="showDrug"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showDrug">
					<el-table ref="multipleTable2" :data="drugs" tooltip-effect="dark" style="overflow:initial" size="small">
						<el-table-column :key="1" prop="title" label="商品名称" width="220" />
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 2" size="small"
									type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="brand" label="品牌" align="center" />
						<el-table-column :key="3" prop="skuValue" label="规格" align="center" width="120">
							<template slot-scope="scope">
								{{scope.row.skuValue == ''?'--':scope.row.skuValue}}
							</template>
						</el-table-column>
						<el-table-column :key="5" prop="unit" label="单位" align="center" />
						<el-table-column :key="4" prop="count" label="数量" align="center" />
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock.length > 0">
										<div v-for="(item,index) in scope.row.shop_stock" :key="index">
											{{item.shop_name}}:{{item.shop_stock}}</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #0000FF;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="9" prop="procureGoodsRemark" label="备注" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.procureGoodsRemark==''?'--':scope.row.procureGoodsRemark}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160" />
					</el-table>
					<div class="allNum">
						<div>共{{drugCount}}件</div>
						<div>合计：{{drugPrice.toFixed(2)}}</div>
					</div>
				</div>
			</div>
			<!-- 耗材类 -->
			<div class="shopClass" v-if="haocais.length > 0">
				<div class="comH2" @click="handleHaocaiClick">
					<div>耗材类</div>
					<i class="el-icon-caret-bottom" v-if="showHaocai"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showHaocai">
					<el-table ref="multipleTable2" :data="haocais" tooltip-effect="dark" style="overflow:initial" size="small">
						<el-table-column :key="1" prop="title" label="商品名称" width="220" />
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 2" size="small"
									type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="brand" label="品牌" align="center">
							<template>
								<span>--</span>
							</template>
						</el-table-column>
						<el-table-column :key="3" prop="skuValue" label="规格" align="center" width="120">
							<template>
								<span>--</span>
							</template>
						</el-table-column>
						<el-table-column :key="5" prop="unit" label="单位" align="center" />
						<el-table-column :key="4" prop="count" label="数量" align="center" />
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock.length > 0">
										<div v-for="(item,index) in scope.row.shop_stock" :key="index">
											{{item.shop_name}}:{{item.shop_stock}}</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #0000FF;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="9" prop="procureGoodsRemark" label="备注" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.procureGoodsRemark==''?'--':scope.row.procureGoodsRemark}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160" />
					</el-table>
					<div class="allNum">
						<div>共{{haocaiCount}}件</div>
					</div>
				</div>
			</div>
			<!-- 修改记录 -->
			<div class="comH2" @click="handleUpdateClick"
				v-if="detailData.updateList && detailData.updateList.length > 0">
				<div>修改记录</div>
				<i class="el-icon-caret-bottom" v-if="showDrug"></i>
				<i class="el-icon-caret-top" v-else></i>
			</div>
			<div class="tableWarp" v-if="showUpadate">
				<el-row class="tableName">
					<el-col :span="12" align="center">原商品</el-col>
					<el-col :span="12" align="center">修改商品</el-col>
				</el-row>
				<el-table :data="detailData.updateList" size="small">
					<el-table-column :key="7" label="商品名称">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{scope.row.procureGoodsReplace.title}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="8" label="品牌">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{scope.row.procureGoodsReplace.brand}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="9" label="规格">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{scope.row.procureGoodsReplace.skuValue}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="10" label="单位">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{scope.row.procureGoodsReplace.unit}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="11" label="采购数量" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{scope.row.procureGoodsReplace.count}}</span>
						</template>
					</el-table-column>
					<el-table-column :key="6">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.state == 0" type="danger" effect="dark">已删除</el-tag>
							<el-tag v-if="scope.row.state == 2" type="success" effect="dark">已添加</el-tag>
							<el-tag v-if="scope.row.state == 4" effect="dark">已变更</el-tag>
						</template>
					</el-table-column>
					<el-table-column :key="1" label="商品名称" prop="procureGoodsReplace.title" />
					<el-table-column :key="2" label="品牌" prop="procureGoodsReplace.brand" />
					<el-table-column :key="3" label="规格" prop="procureGoodsReplace.skuValue" />
					<el-table-column :key="4" label="单位" prop="procureGoodsReplace.unit" />
					<el-table-column :key="5" label="采购数量" prop="procureGoodsReplace.count" align="center" />
				</el-table>
			</div>
		</div>
		<!-- 底部按钮 -->
		<div class="fix_btn">
			<el-button type="warning" @click="dialogFormVisible = true" size="small">查看驳回理由</el-button>
			<el-button type="warning" @click="handleCHClick" size="small">撤回驳回</el-button>
		</div>
		<el-dialog :visible.sync="dialogFormVisible" width="940">
			<el-row style="font-size: 14px;margin-bottom: 20px;color: #2A2A2A;">
				<el-col :span="7" v-if="detailData.checkInfo">审批人:{{detailData.checkInfo.checkUserInfo.userName}}
				</el-col>
				<el-col :span="7" v-if="detailData.checkInfo">审批日期: {{detailData.checkInfo.checkUserInfo.operationTime}}</el-col>
			</el-row>
			<div style="color: #2A2A2A;font-size:14px;margin-bottom: 20px;">驳回理由</div>
			<el-row style="font-size:16px;">
				<el-col v-if="detailData.checkInfo">{{detailData.checkInfo.checkRemark}}</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>
<script>
	import {
		single,
	
	} from '@/api/purchaseApi.js'
	import { procureRequestDl} from "@/api/shopPurchaseApiNew.js"
	import { shopConfirm,getCheck,removegoods,updategoods,checkrejected} from "@/api/purchaseApiNew.js"
	import caigouFilter from '@/util/caigouFilter.js'
	export default {
		data() {
			return {
				shopList: [],
				fixedHeight: '',
				procureRequestNo: this.$route.query.procureRequestNo, //跳转订单procureRequestNo
				detailData: {}, //订单详情
				allPrice: 0, //商品总价
				sqDate: '', //申请时间
				expect_time: '', //审批时间
				shops: [], //商品类
				drugs: [], //药品类
				haocais: [], //耗材类
				showShop: true, //显示商品类
				showDrug: true, //显示药品类
				showHaocai: true, //显示耗材类
				showUpadate: true, //显示修改记录
				shopCount: 0,
				shopPrice: 0,
				drugCount: 0,
				drugPrice: 0,
				haocaiCount: 0,
				haocaiPrice: 0,
				stockVisible: false, //库存
				shopStocks: [],
				dialogFormVisible: false, //显示隐藏弹框
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getDetailData()
		},
		methods: {
			//返回按钮
			handleBackClick() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.back();
					let storage = window.sessionStorage
					storage.setItem("tabs", 3)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//展开修改记录
			handleUpdateClick() {
				this.showUpadate = !this.showUpadate
			},
			//展开商品类
			handleShopClick() {
				this.showShop = !this.showShop
			},
			//展开药品类
			handleDrugClick() {
				this.showDrug = !this.showDrug
			},
			//展开耗材类
			handleHaocaiClick() {
				this.showHaocai = !this.showHaocai
			},
			//撤销驳回
			handleCHClick() {
				this.$confirm('请问是否撤回驳回？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					let parmars = {
						procureRequestNo: this.procureRequestNo
					}
					checkrejected(parmars).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '已撤回驳回'
							});
							this.$router.go(-1)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//获取详情
			getDetailData() {
				let parmars = {
					procureRequestNo: this.procureRequestNo
				}
				procureRequestDl(parmars).then((res) => {
					if (res.code == 0) {
						this.detailData = res.data;
						// let price = 0;
						let detail = res.data;
						let shopList = []; //商品列表
						let drugList = []; //药品列表
						let haocaiList = []; //耗材列表

						for (let i = 0; i < detail. procureGoodsList.length; i++) {
							let parmars = {
								goodsId: detail.procureGoodsList[i].id,
								skuId: detail.procureGoodsList[i].id,
								zt: i
							}
							if (detail.procureGoodsList[i].goodsType == '0') {
								parmars.skuId = detail. procureGoodsList[i].skuId
							} else {
								parmars.skuId = '';
							}
							single(parmars).then((resolve) => {
								if (resolve.code == 0) {
									if (resolve.data == null) {
										detail.procureGoodsList[i].shop_stock = [];
									} else {
										detail.procureGoodsList[i].shop_stock = resolve.data.skuList[0]
											.shop_stock;
									}

									if (detail. procureGoodsList[i].goodsType == 0 && (detail
											. procureGoodsList[i].procureGoodsState == 1 || detail
											. procureGoodsList[i].procureGoodsState == 2 || detail
											. procureGoodsList[i].procureGoodsState == 4)) {
										shopList[i] = detail. procureGoodsList[i]
									} else if (detail. procureGoodsList[i].goodsType == 1 && (
											detail. procureGoodsList[i].procureGoodsState == 1 || detail
											. procureGoodsList[i].procureGoodsState == 2 || detail
											. procureGoodsList[i].procureGoodsState == 4)) {
										drugList[i] = detail. procureGoodsList[i]
									} else if (detail. procureGoodsList[i].goodsType == 7 && (
											detail. procureGoodsList[i].procureGoodsState == 1 || detail
											. procureGoodsList[i].procureGoodsState == 2 || detail
											. procureGoodsList[i].procureGoodsState == 4)) {
										haocaiList[i] = detail. procureGoodsList[i]
									}
									this.expectTime ='';
									this.shops = shopList.filter(item => item);
									this.drugs = drugList.filter(item => item);
									this.haocais = haocaiList.filter(item => item);
								}
							})
						}

					} else {
						this.$message({
							message: res.info,
							type: 'warning'
						});
					}
				})
			},
			// // 获取合计
			getAllData() {
				let shops = this.shops;
				let drugs = this.drugs;
				let haocais = this.haocais;
				let shopCount = 0;
				let drugCount = 0;
				let haocaiCount = 0;
				if (shops.length > 0) {
					for (let i = 0; i < shops.length; i++) {
						shopCount = (shopCount + shops[i].count);
					}
					this.shopCount = shopCount;
				}
				if (drugs.length > 0) {
					for (let j = 0; j < drugs.length; j++) {
						drugCount = (drugCount + drugs[j].count);
					}
					this.drugCount = drugCount;
				}
				if (haocais.length > 0) {
					for (let k = 0; k < haocais.length; k++) {
						haocaiCount = (haocaiCount + haocais[k].count);
					}
					this.haocaiCount = haocaiCount;
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;

		// 重复头部
		.titleView {
			width: 99%;
			padding: 20px 0;
			padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}

		.scrollView {
			flex: 1;
		}

		.scrollView::-webkit-scrollbar {
			display: none;
		}

		//重复标题
		.comH2 {
			line-height: 64px;
			font-size: 18px;
			display: flex;
			align-items: center;
		}

		.comH2 div {
			margin-left: 20px;
			margin-right: 6px;
			font-weight: bold;
		}

		.comH2 img {
			width: 16px;
			height: 16px;
			background: red;
		}

		.tableWarp {
			border-radius: 6px;
			background: #fff;
			padding: 20px 30px;

			.tableName {
				line-height: 46px;
				background: #F7F6F9;
				font-size: 18px;
				color: #2A2A2A;
				font-weight: bold;
				margin-bottom: 10px;
			}

			.allNum {
				font-size: 14px;
				background: #F5F5F5;
				height: 50px;
				display: flex;
				align-items: center;
				padding-left: 20px;

				div:nth-of-type(1) {
					margin-right: 20px;
				}
			}
		}

		.fix_btn {
			width: 100%;
			height: 72px;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: flex-end;

			button {
				margin-right: 30px;
			}

			button:nth-of-type(5) {
				margin-right: 60px;
			}
		}
	}
</style>
